import React, { useContext, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import useForm from 'hooks/useForm';
import ProfileDetail from 'Components/Users/ProfileDetail';
import ConfigContext from 'Shared/ConfigContext';
import { setProfile } from 'Shared/ConfigContext/Actions';
import Modal from '../Modal';
import { updateProfile, getProfile } from './services';

const SuccessModal = ({ open, setOpen, onCloseAll }) => (
  <Modal open={open} setOpen={setOpen}>
    <Box sx={{ p: '20px 40px', textAlign: 'center' }}>
      <ThumbUpOutlinedIcon fontSize="large" color="primary" />
      <Typography sx={{
        color: '#8F8F8F', fontSize: 14, fontWeight: 600, mt: 2.5, mb: 2.5,
      }}
      >
        Modification enregistrée avec succès
      </Typography>
      <Button onClick={onCloseAll} variant="contained" color="primary" sx={{ textTransform: 'capitalize' }}>
        Fermer
      </Button>
    </Box>
  </Modal>
);

const ProfileInfo = () => {
  const { dispatch: dispatchConfig, state: { profile } } = useContext(ConfigContext);
  const { values, onChange } = useForm(profile);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const onGetProfile = async () => {
    const data = await getProfile();
    dispatchConfig(setProfile(data));
  };

  const onSubmit = async (data) => {
    await updateProfile(data);
    onGetProfile();
    if (!isSmallScreen) setOpen(true);
  };

  return (
    <Box sx={{ p: { xs: '10px 10px 100px', sm: '10px 150px 100px' } }}>
      <Typography sx={{
        color: '#4D4D4D',
        fontSize: { xs: '16px', sm: 21 },
        fontWeight: 600,
        textAlign: { xs: 'left', sm: 'center' },
        mb: 4,
      }}
      >
        Mes informations personnelles
      </Typography>
      <ProfileDetail user={values} onChange={onChange} onSubmit={onSubmit} />
      <SuccessModal open={open} setOpen={setOpen} onCloseAll={() => setOpen(false)} />
    </Box>
  );
};

export default ProfileInfo;
